import axios from 'axios';
import { authService } from '../services/authService';

// Create an axios instance with base URL
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/dev',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor to check token before making API calls
api.interceptors.request.use(
  (config) => {
    // Check if this is an authenticated request (has Authorization header)
    if (config.headers && config.headers.Authorization) {
      // Check token expiration
      if (!authService.checkTokenExpiration()) {
        // Token expired and user is being redirected
        return Promise.reject(new Error('Token expired'));
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle specific error cases
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      if (error.response.status === 401) {
        // Unauthorized - redirect to login or refresh token
        console.log('Unauthorized request');
        // Check token and redirect if expired
        authService.checkTokenExpiration();
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.log('No response received:', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error setting up request:', error.message);
    }
    return Promise.reject(error);
  }
);

export default api;
